import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Innovative Android App Development Company in Dubai to Elevate
              Your Business
            </h2>
            <p>
              As a top Android app development firm in Dubai, we’re your doorway
              to revolutionary solutions. Our goal is to help you grow your
              business by offering creative Android mobile app development in
              Dubai. Our dedication to quality and recognition of the
              significance of economy of scale are what distinguish us.
            </p>
            <p>
              We provide affordable app development prices without sacrificing
              quality as a custom Android app development company in Dubai. You
              can get the finest return on your investment and enjoy the power
              of cutting-edge Android apps with TekRevol.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <StaticImage
              src="../../images/location_new/fold5/and-dubai.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={866}
              height={1042}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
